import { useState } from 'react';
import { Link } from 'react-router-dom';
import dog from '../../asstes/images/img1.png';
import pal from '../../asstes/images/girl_dog.png';
import parent from '../../asstes/images/people_dog.png';
const content = {
  all: {text: "Social Paws invites ALL dog-lovers into our community — those who own dogs and those who don't!", image: dog, alt: 'Dog carrying a leash'},
  pal: {text: 'You’re a Pup Pal if you love dogs, don’t have one, and would love to spend time with a neighbor’s dog!', image: pal, alt: 'A dog lover spending time with a dog'},
  parent: {text: 'You’re a Pup Pawrent if you’re a dog owner looking for extra support with dog care and are open to sharing your pup’s love with a neighbor!', image: parent, alt: 'A neighbor walking a dog'}
};
export default function ScrollingText() {
  const [selected, setSelected] = useState('all');
  const current = content[selected];
  return <section className="home-community" data-selected={selected}><div className="home-container">
    <h2>Which type of Dog-Lover are you?</h2>
    <div className="community-grid">
      <p className="community-intro">{content.all.text}</p>
      <div className="community-options" role="group" aria-label="Choose your dog-lover type">
        <button aria-pressed={selected === 'pal'} onClick={() => setSelected('pal')} aria-controls="community-description">Pup Pal</button>
        <button aria-pressed={selected === 'parent'} onClick={() => setSelected('parent')} aria-controls="community-description">Pup Pawrent</button>
      </div>
      <p id="community-description" className="community-description" aria-live="polite">{current.text}</p>
      <Link className="community-learn" to="/about_us">Learn more</Link>
    <picture className="community-picture"><img src={current.image} alt={current.alt}/></picture></div>
  </div></section>;
}
